import { fetchCreative } from './fetchers/fetch-creative.js';
import { fetchExtrasFactory } from './fetchers/extras-factory.js';
import prepareCreative from './prepare-creative/index.js';
import {
  defer,
  from,
  map,
  retry,
  switchMap,
  tap,
  throwError,
  timeout,
  timer,
} from 'rxjs';
import { Cache } from '#/utils/cache.js';
import AssetLoader from './fetchers/assets-loader/asset-loader.js';
import { createLinkInterpolation } from '#/providers/creative/create-link-interpolation.js';
import { patchSchema } from '#/providers/creative/patch-schema.js';

const assetLoader = new AssetLoader();

/**
 * One timeout for all:
 *  - loading scheme with all retry
 *  - success preload all assets with there owns retry
 */
const SCHEME_FETCH_TIMEOUT = timeout({ first: 30_000 });
const RETRYING = retry({
  count: 2,
  delay(error, retryCount) {
    /* retry only for error having status, e.g. http request errors.
     Do not retry for TypeError e.g. blocked request  */
    return error.status && error.status !== 404 ? timer(1_000 * retryCount) : throwError(error);
  },
});

export default function CreativeProvider(cache = new Cache({ TTL: 600_000 }), dependencies = {}) {
  const fetchExtras = fetchExtrasFactory(dependencies);
  const linkInterpolation = createLinkInterpolation(dependencies);
  return {
    getByUrl,
  };

  function getByUrl(url) {
    const cached = cache.forKey(url.replace(/&rnd=[^&]+/, ''));
    const creative = cached.get();
    if (creative) {
      // repeat preloadAssets in case of cached creative,
      // due to real access to image could be lost after some time
      return assetLoader.loadAssets(linkInterpolation(creative));
    }

    const fetchFactory = () => {

      return from(fetchCreative(url)
        .then(patchSchema)
        .then(fetchExtras));
    };

    return defer(fetchFactory).pipe(
      RETRYING,
      map(prepareCreative),
      switchMap((creative) => assetLoader.loadAssets(creative)),
      tap(cached.set),
      map(linkInterpolation),
      SCHEME_FETCH_TIMEOUT,
    );
  }
}
